import React from 'react';
import './PromoBanner.css';

export default function PromoBanner({ text }) {
  return (
    <div className="promo-banner">
      <p>{text}</p>
    </div>
  );
}
